import React, { useEffect, useState } from "react";
import { Mail, Loader2, CheckCircle2, Save } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useLang } from "@/context/LangContext";

// بريد استقبال إشعارات النشر التلقائي (يختلف عن بريد الدخول عند الحاجة)
export const NotifyEmail = () => {
  const [email, setEmail] = useState("");
  const [stored, setStored] = useState(""); // القيمة المحفوظة فعلًا في الخادم
  const [accountEmail, setAccountEmail] = useState("");
  const [saving, setSaving] = useState(false);
  const { t } = useLang();
  const dirty = email.trim().toLowerCase() !== (stored || "").toLowerCase();
  const isSaved = !!stored && !dirty;

  useEffect(() => {
    api.get("/social/notify-email").then(({ data }) => { setEmail(data.email || ""); setStored(data.email || ""); setAccountEmail(data.account_email || ""); }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/social/notify-email", { email });
      setEmail(data.email); setStored(data.email); toast.success(t("تم حفظ بريد الإشعارات ✅", "Notification email saved ✅"));
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className={`rounded-2xl border p-4 flex flex-col gap-2 ${isSaved ? "border-emerald-500/40 bg-emerald-500/5" : "border-border bg-card"}`} data-testid="notify-email-box">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex items-center gap-2 text-sm font-bold shrink-0"><Mail className="w-4 h-4 text-primary" /> {t("بريد إشعارات النشر", "Publishing notification email")}</div>
        <Input dir="ltr" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && dirty && email && save()} placeholder={accountEmail || "name@example.com"} className="flex-1" data-testid="notify-email-input" />
        {isSaved ? (
          <span className="inline-flex items-center gap-1 h-9 px-3 rounded-md text-xs font-bold text-emerald-700 dark:text-emerald-400 bg-emerald-500/15 shrink-0" data-testid="notify-email-saved">
            <CheckCircle2 className="w-4 h-4" /> {t("محفوظ ✓", "Saved ✓")}
          </span>
        ) : (
          <Button size="sm" onClick={save} disabled={saving || !email.trim() || !dirty} className="gap-1 shrink-0" data-testid="notify-email-save">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} {t("حفظ", "Save")}
          </Button>
        )}
      </div>
      <p className="text-[11px] text-muted-foreground" data-testid="notify-email-hint">
        {isSaved
          ? <>{t("ستصل إشعارات «تم نشر منشورك» وتنبيهات الفشل إلى", "“Your post is live” emails and failure alerts go to")} <b dir="ltr" className="text-foreground">{stored}</b>{t("، عدّل البريد ثم احفظ لتغييره.", ". Edit the address and save to change it.")}</>
          : t("يصلك هنا بريد «تم نشر منشورك» برابطه بعد كل نشر تلقائي، وتنبيه عند أي فشل.", "You receive a “your post is live” email with its link after every automatic publish, and an alert on any failure.")}
      </p>
    </div>
  );
};
